import { cn } from "@/lib/utils";
import {
  maskitoNumberOptionsGenerator,
  maskitoParseNumber,
} from "@maskito/kit";
import { useMaskito } from "@maskito/react";
import { useEffect, useState } from "react";

const formatNumber = (num: number | null | undefined): string => {
  if (num === null || num === undefined) {
    return "";
  }

  const numString = num.toString();

  const parts = numString.split(".");
  let integerPart = parts[0];
  const decimalPart = parts[1] ? parts[1] : "";

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  if (decimalPart) {
    return `${integerPart},${decimalPart}`;
  }

  return integerPart;
};

const mask = maskitoNumberOptionsGenerator({
  minusSign: "-",
  thousandSeparator: ".",
  decimalSeparator: ",",
  precision: 2,
});

export const CurrencyInputCell = ({
  value,
  saveHandler,
  prefix,
  className,
  key,
}: {
  value: number | null;
  key: string;
  prefix?: string;
  saveHandler: (value: number | null) => Promise<void>;
  className?: string;
}) => {
  const onBlur = async () => {
    if (amount === "") {
      saveHandler(null);
      return;
    }
    const number = maskitoParseNumber(amount, ",");
    if (!Number.isNaN(number)) {
      saveHandler(number);
    }
    await saveHandler(number);
  };

  const [amount, setAmount] = useState<string>(formatNumber(value));

  useEffect(() => {
    setAmount(formatNumber(value));
  }, [value]);

  const maskedInputRef = useMaskito({ options: mask });

  const handleChange = (value: string) => {
    setAmount(value);
  };

  return (
    <div
      className={cn(
        "overflow-hidden justify-start flex items-center text-ellipsis pt-2.5 pb-2.5 overflow-hidden w-full",
      )}
    >
      <div className="text-xs font-semibold ml-2 mr-1 w-5">{prefix}</div>
      <input
        key={key}
        value={amount}
        ref={maskedInputRef}
        onBlur={onBlur}
        className={cn(
          "flex h-10 w-full rounded-md border-none bg-transparent px-3 py-0 text-sm ring-offset-0 focus-visible:outline-none placeholder:text-transparent disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        )}
        onInput={(event: any) => {
          handleChange(event.target.value);
        }}
      />
    </div>
  );
};
